import Image from '@components/Image';
import styled from '@emotion/styled';

import useStampSheet from './hooks/useStampSheet';

interface Props {
    onSuccess?: Function;
    onFailure?: Function;
    backgroundImageUrl?: string;
}

function StampSheet({ onSuccess, onFailure, backgroundImageUrl }:Props) {
    const { handleTouchStart } = useStampSheet({ onSuccess, onFailure });

    return (<Container onTouchStart={handleTouchStart} >
        {/* <Target/> */}
        {backgroundImageUrl && (
            <BackgroundImage src={backgroundImageUrl} />
        )}
    </Container>);
}

const Container = styled.div`
    width: 100%;
    aspect-ratio: 1;
    background-color: var(--color-gray7);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const BackgroundImage = styled(Image)`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export default StampSheet;
